import "../reportDashboard.scss";

const RADIUS = 45;
const CIRC = 2 * Math.PI * RADIUS;

// Pure-SVG donut — replaces the chart.js DashboardDonut on cards that need
// the ring-left / legend-right layout (Overview's Finding Type Distribution).
// Arcs are chained clockwise starting at 12 o'clock, one per segment; colour
// comes from a tone class on the <circle> (never an inline colour).
// props: { total, segments: [{ label, value, tone }], centerCaption }
const DonutRing = ({ total, segments = [], centerCaption = "ITEMS" }) => {
  let offset = CIRC * 0.25;

  return (
    <div className="rdDonut">
      <svg className="rdDonut__svg" viewBox="0 0 120 120" width="110" height="110">
        <circle className="rdDonut__track" cx="60" cy="60" r={RADIUS} strokeWidth="16" />
        {segments.map((s) => {
          const frac = total > 0 ? s.value / total : 0;
          const dash = CIRC * frac;
          const dashOffset = -offset;
          offset += dash;
          return (
            <circle
              key={s.label}
              className={`rdDonut__arc is-${s.tone}`}
              cx="60"
              cy="60"
              r={RADIUS}
              strokeWidth="16"
              strokeDasharray={`${dash} ${CIRC - dash}`}
              strokeDashoffset={dashOffset}
            />
          );
        })}
        <text className="rdDonut__total" x="60" y="56" textAnchor="middle" fontSize="18">
          {total}
        </text>
        {/* The ring's inner edge sits at r=37 (RADIUS 45 - strokeWidth 16), leaving
            only ~6px of clearance on either side of this text at fontSize 7 — fine
            for the one caption every caller currently passes ("ITEMS"), but a
            longer word has no room to grow into before it crowds the arc. Scaling
            down past ~6 characters keeps a future longer caption inside that
            clearance instead of touching the ring. */}
        <text
          className="rdDonut__caption"
          x="60"
          y="70"
          textAnchor="middle"
          fontSize={centerCaption.length > 6 ? 7 * (6 / centerCaption.length) : 7}
        >
          {centerCaption}
        </text>
      </svg>
      <div className="rdDonut__legend">
        {segments.map((s) => (
          <div className="rdDonut__legendRow" key={s.label}>
            <span className={`rdSwatch is-${s.tone}`} />
            <span className="rdDonut__legendLabel">{s.label}</span>
            <span className="rdDonut__legendValue">{s.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutRing;
